import { render } from "./MSTodoAddModal.vue?vue&type=template&id=70493440&scoped=true&ts=true"
import script from "./MSTodoAddModal.vue?vue&type=script&lang=ts"
export * from "./MSTodoAddModal.vue?vue&type=script&lang=ts"

import "./MSTodoAddModal.vue?vue&type=style&index=0&id=70493440&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70493440"]])

export default __exports__